'use es6';

import keyMirror from 'react-utils/keyMirror';
export default Object.freeze(keyMirror({
  CSS_COLOR: null,
  CSS_BACKGROUND_COLOR: null,
  CSS_BORDER_COLOR: null,
  CSS_BORDER_WIDTH: null,
  CSS_MARGIN_BOTTOM: null,
  CSS_MARGIN_LEFT: null,
  CSS_MARGIN_RIGHT: null,
  CSS_MARGIN_TOP: null,
  CSS_PADDING_BOTTOM: null,
  CSS_PADDING_LEFT: null,
  CSS_PADDING_RIGHT: null,
  CSS_PADDING_TOP: null
}));